"use client"
import styled from "@emotion/styled"
import { Container, NewText } from "ui"
import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils/extractProperty"

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  align-items: center;
  p {
    margin: 0px;
    margin-bottom: 8px;
  }
`

const StyledContainerInner = styled.div`
  padding-top: 32px;
  max-width: 800px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 32px;
    width: 800px;
  }
`
const StyledWrapper = styled.div`
  background: url("/images/heroBG.png"), ${(props) => props.theme.colors.propBlue};
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-size: contain;
  margin-bottom: 32px;
  margin-left: 16px;
  margin-right: 16px;
  border-radius: 8px;
  > div > div {
    background: transparent;
    display: inline-block;
  }
  div,
  h1,
  p {
    margin-left: auto;
    margin-right: auto;
    color: white;
    text-align: center;
  }
  h1 {
    font-size: 40px;
    max-width: 675px;
  }
  div,
  p {
    font-size: 24px;
  }
  p {
    max-width: 675px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    min-width: 100vw;
    margin-bottom: 44px;
    margin-left: 0;
    margin-right: 0;
    background-position-y: center;
    border-radius: unset;
    h1 {
      font-size: 48px;
    }
    div,
    p {
      font-size: 18px;
    }
  }
`

export const ContentText: React.FC = ({ data, hasBanner }: any) => {
  const conetntTitle = extractProperty(data, "conetntTitle")
  const subTitle = extractProperty(data, "subTitle")
  const innerText = extractProperty(data, "innerText")

  if (!hasBanner) {
    return (
      <StyledWrapper>
        <StyledContainer>
          <StyledContainerInner>
            <NewText
              desktopFontSize={32}
              desktopFontWeight="400"
              desktopLineHeight="36px"
              mobileFontSize={24}
              mobileFontWeight="400"
              mobileLineHeight="34.56px"
              component="h2"
              color={sharedColors.black}
              marginBottom={"8px"}
            >
              {conetntTitle}
            </NewText>
            <NewText
              desktopFontSize={16}
              desktopFontWeight="600"
              desktopLineHeight="23px"
              mobileFontSize={14}
              mobileFontWeight="400"
              mobileLineHeight="20px"
              component="h3"
              color={sharedColors.black}
            >
              {subTitle}
            </NewText>
            <NewText
              desktopFontSize={16}
              desktopFontWeight="400"
              desktopLineHeight="23px"
              mobileFontSize={16}
              mobileFontWeight="400"
              mobileLineHeight="20px"
              component="div"
              color={sharedColors.black}
              dangerouslySetInnerHTML={{ __html: innerText }}
            />
          </StyledContainerInner>
        </StyledContainer>
      </StyledWrapper>
    )
  }
  return (
    <StyledContainer>
      <StyledContainerInner>
        <NewText
          desktopFontSize={32}
          desktopFontWeight="400"
          desktopLineHeight="36px"
          mobileFontSize={24}
          mobileFontWeight="400"
          mobileLineHeight="34.56px"
          component="h2"
          color={sharedColors.black}
          marginBottom={"8px"}
        >
          {conetntTitle}
        </NewText>
        <NewText
          desktopFontSize={16}
          desktopFontWeight="600"
          desktopLineHeight="23px"
          mobileFontSize={14}
          mobileFontWeight="400"
          mobileLineHeight="20px"
          component="h3"
          color={sharedColors.black}
        >
          {subTitle}
        </NewText>
        <NewText
          desktopFontSize={16}
          desktopFontWeight="400"
          desktopLineHeight="23px"
          mobileFontSize={16}
          mobileFontWeight="400"
          mobileLineHeight="20px"
          component="div"
          color={sharedColors.black}
          dangerouslySetInnerHTML={{ __html: innerText }}
        />
      </StyledContainerInner>
    </StyledContainer>
  )
}

export default ContentText
